import * as React from "react";
import { ConfirmDialog, toast } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { DELETE_CARD_PRESET } from "../../graphql/cardPresets";

interface DeleteCardSettingsModalProps {
  open: boolean;
  handleCloseModal: (isRefetchData: boolean) => void;
  selectedId: string;
}

const DeleteCardSettingsModal: React.FC<DeleteCardSettingsModalProps> = (
  props,
) => {
  const { open, handleCloseModal, selectedId } = props;

  const { t } = useTranslation();

  const [deleteCardPreset, { loading }] = useMutation(DELETE_CARD_PRESET, {
    onCompleted: () => {
      handleCloseModal(true);
      toast.success(t("Preset deleted!"));
    },
    onError: (error) => {
      toast.error(error?.message || t("Please try again!"));
    },
  });

  return (
    <ConfirmDialog
      open={open}
      title={t("Remove Configuration")}
      message={t("You are about to delete this card preset Are you sure?")}
      confirmLabel={t("Continue")}
      cancelLabel={t("Cancel")}
      busy={loading}
      onConfirm={() => deleteCardPreset({ variables: { id: selectedId } })}
      // busy swallows only the backdrop; Escape and the title close still reach
      // onCancel, and would read as a cancel while the delete carried on.
      onCancel={() => {
        if (loading) return;
        handleCloseModal(false);
      }}
    />
  );
};

export default DeleteCardSettingsModal;
